<template>
  <v-layout>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="vendors"
        class="elevation-3 item-table"
        :loading="$store.state.loading > 0"
        :pagination.sync="pagination"
        item-key="_id"
      >
        <!--template slot="headers" slot-scope="props">
          <tr class="headerrow">
            <th class="headercell" v-for="header in props.headers" :key="header.text">{{header.text}}</th>
          </tr>
        </template -->
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <tr v-if="editingItem !== props.item.rowId">
            <td class="justify-center layout px-0" nowrap>
              <v-icon
                small
                class="mr-2"
                @click="editVendor(props.item.rowId)"
              >edit</v-icon>
                <v-icon
                small
                class="mr-2"
                @click="deleteVendor(props.item.rowId)"
              >delete</v-icon>
            </td>
            <td>{{ props.item._id }}</td>
            <td class="headercell">{{ props.item.vendorName }}</td>
            <td>{{ props.item.dateAdded }}</td>
            <td>{{ props.item.addedBy }}</td>
          </tr>
          <tr v-if="editingItem === props.item.rowId">
            <td class="justify-center layout px-0" nowrap>
              <v-icon
                small
                class="mr-2"
                @click="saveVendor(props.item)"
              >save</v-icon>
            </td>
            <td><v-text-field hide-details label="Vendor ID" v-model="props.item._id"/></td>
            <td><v-text-field hide-details label="Vendor Name" v-model="props.item.vendorName"/></td>
            <td>{{ props.item.dateAdded }}</td>
            <td>{{ props.item.addedBy }}</td>
          </tr>
        </template>
      </v-data-table>
       <v-card-actions>
            <v-layout>
              <v-btn
                  color="success"
                  @click="addVendor()"
              >
                Add Vendor
              </v-btn>
            </v-layout>

          </v-card-actions>
      </v-card>
  </v-layout>
</template>

<script>
import http from '../http';
import { baseApiUrl } from '../config';
import moment from 'moment';

export default {
  name: "Vendor",
  data() {
    return {
      headers: [
        { text: "Actions", value: "actions" },

        { text: "ID", value: "_id", sortable: true },
        { text: "Name", value: "vendorName" },
        { text: "Date Added", value: "dateAdded" },
        { text: "Added By", value: "addedBy" },
      ],
      filter: "All",
      search: "",

      editingItem: undefined,
      pagination: {
        rowsPerPage: 40
      },
      vendors: []
    };
  },
  methods: {
    editVendor(rowId) {
      console.log('editVendor rowId:', rowId);
      this.editingItem = rowId;
    },
    async deleteVendor(rowId) {
      console.log('deleteVendor:', rowId);
      const vendorIndex = this.vendors.findIndex(v => v.rowId === rowId);
      await http.delete(`${baseApiUrl}/admin/vendor/delete/${this.vendors[vendorIndex]._id}`);
      await this.loadVendors();
    },
    async saveVendor(vendor) {
      console.log('saveVendor vendor:', vendor._id);
      this.editingItem = undefined;
      if (!vendor._id || !vendor.vendorName) return;
      
      vendor.approvedDate = moment();
      vendor.addedBy = this.$store.state.user.attributes.name;

      await http.post(`${baseApiUrl}/admin/vendor/${vendor._id}`, vendor);
      await this.loadVendors();
    },
    addVendor() {
      const rowId = new Date().getTime();

      this.vendors.push({
        rowId,
        _id: '',
        vendorName: '',
        addedBy: this.$store.state.user.attributes.name,
        dateAdded: moment(),
      });

      this.editingItem = rowId;
    },
    async loadVendors() {
      console.log('fetching vendors...');
      const vendors = await http.get(`${baseApiUrl}/vendors`);
      this.vendors = vendors.data;
    }
  },
  async beforeCreate() {
    console.log('fetching vendors...');
    const vendors = await http.get(`${baseApiUrl}/vendors`);
    this.vendors = vendors.data;
  }
};
</script>

<style>
.item-table {
  table-layout: fixed !important;
}

.headerrow {
  padding: 2px;
}

.headercell {
  white-space: normal !important;
}
</style>
